import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonalVisitActionBarComponent } from './component/personal-visit-action-bar.component';
import { MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { CommonLayoutModule, CommonUIElementsModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [
    PersonalVisitActionBarComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    CommonLayoutModule,
    CommonTranslationModule,
    CommonUIElementsModule
  ]
})
export class PersonalVisitActionBarModule { }
